var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination-nav',{attrs:{"link-gen":_vm.page_link,"number-of-pages":_vm.number_of_pages,"use-router":""},on:{"change":function($event){return _vm.scroll_to_top()}}})}
var staticRenderFns = []

export { render, staticRenderFns }